export default function (state = { field: false, msg: "" }, action) {
  switch (action.type) {
    case "GET_MSG":
      return { field: action.payload.field, msg: action.payload.msg };
      break;
    default:
      return state;
  }
}
